const tokenService = {
    // トークンの有効性を確認する関数
    isTokenValid(token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1])); // トークンのペイロードを解析
        const currentTime = Math.floor(Date.now() / 1000); // 現在時刻を取得（秒単位）
        return payload.exp > currentTime; // 有効期限と比較
      } catch (e) {
        console.error('Invalid token format:', e);
        return false; // 不正なトークン形式の場合
      }
    },
  
    // トークンを使ってヘッダーを作成する関数
    createHeaders() {
      const idToken = this.getSessionToken('id_token');
    
      if (!idToken) {
        alert('認証が必要です。再度ログインしてください。');
        window.location.href = '/admin-login';
        return;
      }
    
      if (!this.isTokenValid(idToken)) {
        alert('認証が切れています。再度ログインしてください。');
        window.location.href = '/admin-login';
        return;
      }
    
      return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      };
    },

    getSessionToken(name) {
      return sessionStorage.getItem(name);
    },
  
    setSessionToken(name, value) {
      sessionStorage.setItem(name, value);
    },
  
    deleteSessionToken(name) {
      sessionStorage.removeItem(name);
    },
    
    isTokenExpired(token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const exp = payload.exp * 1000;
        return Date.now() > exp;
      } catch (e) {
        return true;
      }
    }
}
  
export default tokenService;